import { Link } from "react-router-dom";
import { works } from "@/mocks/works";

const hot = [
  works.find((w) => w.id === "zuihouyiyefanzhuan")!,
  works.find((w) => w.id === "daojishi")!,
  works.find((w) => w.id === "pingxingzuian")!,
];

const ranked = [
  works.find((w) => w.id === "wuwuchengan")!,
  works.find((w) => w.id === "lianhuansaizheng")!,
  works.find((w) => w.id === "hongxie")!,
  works.find((w) => w.id === "mishituotuozhinan")!,
];

export default function HotSection() {
  return (
    <section
      id="hot"
      className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20"
    >
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            <i className="ri-fire-line text-primary-400" aria-hidden="true"></i>
            热门推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            推理爱好者的高人气选择，口碑与热度双高
          </p>
        </div>
      </div>

      {/* 主推横幅 */}
      <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
        {hot.map((w, i) => (
          <Link
            key={w.id}
            to={`/work/${w.id}`}
            className={`group relative overflow-hidden rounded-lg border border-background-200/60 bg-background-100 transition-colors hover:border-accent-300/50 ${
              i === 0 ? "lg:col-span-1" : ""
            }`}
          >
            <div className="relative aspect-[16/10] w-full overflow-hidden">
              <img
                src={w.cover}
                alt={`${w.title}热门推荐封面`}
                loading="lazy"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent"></div>
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                热推 0{i + 1}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-50 md:text-xl">
                  {w.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-300 md:text-sm">
                  {w.intro}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
                  立即追更
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* 口碑榜 */}
      <div className="mt-10 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4">
        {ranked.map((w, i) => (
          <Link
            key={w.id}
            to={`/work/${w.id}`}
            className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200/60 bg-background-100 p-3 transition-colors hover:border-accent-300/50"
          >
            <span className="w-6 text-center font-heading text-2xl font-black text-accent-400">
              {i + 1}
            </span>
            <div className="h-16 w-12 shrink-0 overflow-hidden rounded bg-background-200">
              <img
                src={w.cover}
                alt={`${w.title}封面`}
                loading="lazy"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h4 className="truncate text-sm font-semibold text-foreground-100">
                {w.title}
              </h4>
              <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex items-center gap-0.5 text-accent-300">
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  {w.rating.toFixed(1)}
                </span>
                <span>{w.views}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}